export const constants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_UPDATE: 'USERS_LOGIN_UPDATE',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
  LOGOUT: 'USERS_LOGOUT',
  RESET_REQUEST: 'USER_RESET_REQUEST',
  RESET_SUCCESS: 'USER_RESET_SUCCESS',
  RESET_FAILUTER: 'USER_RESET_FAILURE'
};
